import { faImage } from '@fortawesome/pro-solid-svg-icons'
import { Avatar, type AvatarProps } from '@mantine/core'

import { type CoreItemCategory } from '@flecto/types'
import { Icon } from '@flecto/ui'
import { getImageUrl } from '@flecto/utils'

import styles from './styles.module.css'

export type AvatarCategoriesProps = AvatarProps & {
  item?: CoreItemCategory
}

export function AvatarCategories({ item, ...props }: AvatarCategoriesProps) {
  const image = item?.thumbnail_url
    ? getImageUrl(item?.thumbnail_url)
    : undefined

  if (image) {
    return <Avatar size='md' {...props} radius='xs' src={image} />
  }

  return (
    <Icon
      withSquareBackground
      size='md'
      icon={faImage}
      color='gray.6'
      className={styles.emptyAvatar}
    />
  )
}
